"use strict";
import $ from "jquery";
import _ from "underscore";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  updating: [],
  updatingDeliveryDocuments: [],
  _cleanInvoice: function(carrierInvoice) {
    var justInvoice = _.omit(carrierInvoice, "loadState");
    justInvoice.tms_line_items_attributes = justInvoice.tms_line_items;
    delete justInvoice.tms_line_items;
    if (justInvoice.source_invoice_amount === "NaN") {
      justInvoice.source_invoice_amount = null;
      justInvoice.amount_to_pay = null;
    }
    return justInvoice;
  },
  runRules: function(carrierInvoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/carrier_invoices/" + carrierInvoiceId + "/run_rules",
        type: "post"
      })
    ).then(DataStoreService.responseHandler, _.identity);
  },
  update: function(carrierInvoiceId, carrierInvoice, customerId) {
    if (_.contains(this.updating, carrierInvoiceId)) {
      return Promise.resolve();
    }
    this.updating.push(carrierInvoiceId);
    const cleanedInvoice = this._cleanInvoice(carrierInvoice);
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/carrier_invoices/" + carrierInvoiceId,
        type: "put",
        data: JSON.stringify({
          carrier_invoice: cleanedInvoice,
          customer_id: customerId
        }),
        contentType: "application/json"
      })
    ).then((data) => {
      DataStoreService.updateStores(data);
      this.updating.splice(this.updating.indexOf(carrierInvoiceId));
      return {};
    }).catch((err) => {
      this.updating.splice(this.updating.indexOf(carrierInvoiceId));
      return { error: err };
    });
  },
  markAsException: function(carrierInvoiceId, note, emailId, exceptionMessages, payment, carrierId) {
    return this._save("save_with_errors", carrierInvoiceId, {
      note,
      email_id: emailId,
      exception_messages: exceptionMessages,
      payment,
      carrier_id: carrierId
    });
  },
  markAsProcessed: function(carrierInvoiceId, payment, carrierId, note, approve, carrierInvoice) {
    return this._save("mark_as_processed", carrierInvoiceId, {
      payment,
      carrier_id: carrierId,
      note,
      approve,
      carrier_invoice: this._cleanInvoice(carrierInvoice)
    });
  },
  _save: function(method, carrierInvoiceId, args) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/carrier_invoices/" + carrierInvoiceId + "/" + method,
        type: "post",
        contentType: "application/json",
        data: JSON.stringify(args || {})
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  unApprove: function(carrierInvoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post(
        "/api/carrier_invoices/" + carrierInvoiceId + "/unapprove",
        {}
      ).then(function(data) {
        DataStoreService.updateStores(data);
        return data;
      })
    );
  },
  abandon: function(carrierInvoiceId, reason) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/carrier_invoices/" + carrierInvoiceId + "/abandon", {
        reason
      }).then(function(data) {
        DataStoreService.updateStores(data);
        return data;
      })
    );
  },
  forwardInvoiceDocumentsToTriumph: function(carrierInvoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/carrier_invoices/" + carrierInvoiceId + "/forward_invoice_documents_to_triumph",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({ id: carrierInvoiceId })
      }).then(DataStoreService.responseHandler, _.identity)
    );
  },
  revive: function(carrierInvoiceId) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/carrier_invoices/" + carrierInvoiceId + "/revive").then(
        function(data) {
          DataStoreService.updateStores(data);
          return data;
        }
      )
    );
  }
};
